import {merge_normal_and_special_hours, weekdays, timeConvert} from "../helpers";

export default {
  template: '#vue-store-pickup-location',
  delimiters: ['${', '}'],
  props: {
    place: Object,
    cart_item_key: String
  },
  computed: {},
  data() {
    let hours = [];
    let has_special_hours = false
    if (this.place.opening_hours) {
      const store_hours = merge_normal_and_special_hours(this.place.opening_hours, this.place.special_hours)
      hours = store_hours.map((hours, index) => {
        let dow_str = weekdays[this.$store.state.lang]()[index]
        if (hours.special) {
          has_special_hours = true
        }
        if (hours.start && hours.end) {
          return `${dow_str}: ${timeConvert(hours.start)} - ${timeConvert(hours.end)}` + (hours.special ? "*" : '')
        } else {
          return `${dow_str}: ${(this.$store.state.lang === 'en' ? 'CLOSED' : 'FERMÉ')}` + (hours.special ? "*" : '')
        }
      });
    }

    let distance = Math.round((this.place.distance + Number.EPSILON) * 10) / 10
    distance = (distance > 100 ? Math.round(distance) : distance)

    return {
      hours: hours,
      has_special_hours: has_special_hours,
      directions: `https://www.google.com/maps/dir//${this.place.address}, ${this.place.city}, ${this.place.province}`,
      distance: distance
    }
  },
  methods: {
    pickupFromModal() {
      // This emission is handled from either the product.js or cart.js component - product info is only used by cart
      if (this.$store.state.global_components.product) {
        this.$store.state.global_components.product.addToCart(null, this.place.store_number);
      } else {
        this.$store.state.global_components.cart.togglePickup(this.cart_item_key, this.place.store_number);
      }
      this.$store.state.global_components.overlay.hideOverlay();
    },
  }
}